// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Dqjg","dragIcon":"Choice_dragIcon__1-0rL","left":"Choice_left__21C_U","input":"Choice_input__27Xb4"};